import { queryClient } from "utils/react-query";

const collection = "timesheet";
const draftCollection = "draft_timesheet";

export const timesheetKeys = {
  log: (date) => [collection, date],
  draftLog: (date) => [collection, "draft", date],
  // Acknowledgement
  acklmnt: (date) => [collection, "acklmnt", date],

  review: (date, filters) => [collection, date, filters],
  calendar: (monthYear) => [collection, "calendar", monthYear],
  // Unique calendar keys for different views
  logCalendar: (monthYear) => [collection, "calendar", "log", monthYear],
  reviewCalendar: (monthYear) => [collection, "calendar", "review", monthYear],
  // Unlock
  unlock: (date) => [collection, "unlock", date],
  // Keys for Log items
  logProjects: (date) => [collection, "log", "projects", date],
  logProjectJobs: (project, date) => [
    ...timesheetKeys.logProjects(date),
    project,
  ],
  logJobMilestones: (project, job, date) => [
    ...timesheetKeys.logProjectJobs(project, date),
    job,
  ],
  logTags: () => [collection, "log", "tag"],
  thisMonthTimesheet: (startDate) => [collection, "month", startDate],
  last7DaysTimesheet: (startDate) => [collection, "week", startDate],
  thisMonthDraftTimesheet: (startDate) => [draftCollection, "month", startDate],
  thisMonthPayrollHours: (startDate) => [
    collection,
    "acklmnt",
    "month",
    startDate,
  ],
  thisWeekPayrollHours: (startDate) => [
    collection,
    "acklmnt",
    "week",
    startDate,
  ],
  pendingJobReviewHours: () => [collection, "job-coordinators-pending-review"],
  pendingProjectReviewHours: () => [
    collection,
    "project-coordinators-pending-review",
  ],
};

export function invalidateTimesheetQueries(date) {
  const predicates = [
    ({ queryKey }) => {
      const isThere = queryKey[0] === "timesheet" && queryKey[1] === date;
      console.log(
        isThere,
        " ",
        queryKey[0] === "timesheet" && queryKey[1] === date,
      );

      return isThere;
    },
    ({ queryKey }) => queryKey.includes("calendar"),
    ({ queryKey }) => queryKey[0] === "timesheet" && queryKey[1] === "list",
  ];

  predicates.forEach((predicate) => {
    queryClient.invalidateQueries({ predicate });
  });
}
